module.exports = __webpack_public_path__ + "img/f18.59801f5c.png";